import React from 'react';
import {Input, Textarea, RichTextarea} from 'components/vitrade-forms/common';
import './_business-content-section.scss';

class BusinessContentDetailItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      title: this.props.title,
      initialContent: this.props.content
    }
  }

  // value={this.state.initialIntroductionData}
  onChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    this.setState({
      ...newState
    });

    let {title, content} = newState;

    this.props.onChange({title, content});
  }

  render() {
    return (
      <div className="business-tab-item">
        <div className='content-justify business-tab-item-title-wrap'>
          <button className="business-tab-item-btn-delete" type='button' onClick={this.props.onItemRemove}>Xóa khối</button>
        </div>
        <input className="business-tab-item-name" placeholder="Tiêu đề ..."
          value={this.state.title}
          onChange={this.onChange.bind(this, 'title')}
          maxLength={50}
        />
        <RichTextarea type="text" placeholder="Mô tả..."
          heading={
            () => <h3 className='wrap-product-des-title'>Nội dung</h3>
          }
          className='wrap-product-des'
          inputClassName='product-des-input'
          iconFontSet='glyphicon'
          iconClassName='glyphicon-user'
          value={this.state.initialContent}
          onChange={this.onChange.bind(this, 'content')}
          required={true}
          bindValidator={this} channel="formPostProduct"
          errorMessage="Nội dung..."
        />
      </div>
    );
  }
}

export default BusinessContentDetailItem;



// WEBPACK FOOTER //
// ./components/my-business/profile/BusinessContentDetailItem.jsx